import React from 'react';
import PropTypes from 'prop-types';

export default class WarningTip extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isActive: false
        };
    }

    componentDidMount() {
        document.addEventListener('click', this.handleClick, false);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClick, false);
    }

    handleClick = (event) => {
        if (!this.node || !this.node.contains(event.target)) {
            this.setState({isActive: false});
            return true;
        }
        event.preventDefault();
        this.setState({isActive: true});
    };

    render() {
        let classes = 'has-tooltip has-tooltip--bottom margin--10--left';
        if (this.props.isLarge) {
            classes += ' has-tooltip--large';
        }
        if (this.state.isActive) {
            classes += ' is-active';
        }
        return (
            <span className={classes} ref={node => this.node = node}>
                <img src="/img/icon-alert--orange.svg" alt="" width="20" height="20" style={{position:"relative",top:-9}}/>
                <span className="is-tooltip" style={{"--left":"50%"}}>
                    {this.props.children}
                </span>
            </span>
        )
    }
}

WarningTip.propTypes = {
    isLarge: PropTypes.bool,
    children: PropTypes.element,
};
